import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup ,
    Navbar ,
    NavRight
} from 'framework7-react';




import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import validator from "validator";
import * as axios from "axios/index";
import Loading from "../Loader/Loading";
import * as vars from './Vars';
import LoginSingUp from './LoginSingUp';

class Profile extends Component{

    constructor(props){
        super(props)
        this.state = {
            goToLoginSignUp : localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null ,
            fields : {
                name : localStorage.getItem('name') ,
                telephone : localStorage.getItem('telephone') ,

                newName : localStorage.getItem('name') ,
                newTelephone : localStorage.getItem('telephone') ,
            } ,
            errors : {} ,


            requestLoading : true ,
            userAddress : [] ,
            deliveryList : [] ,

            requestInPageLoading : false ,
            modal : {
                modalMessageShow : false ,
                modalMessageBody :  "",
                modalMessageTitle : "" ,


            },

            nameModal : false ,
            tellModal : false ,

            requestError : false

        }
    }

    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
            }
        })
    }


    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }


    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        /*if (validator.isEmpty(fields.address))
        {
            formIsValid = false;
            errors['address'] = 'آدرس خود را وارد کنید';
        }
        else if(! validator.isLength(fields.address , { min : 1 , max : 99999}))
        {
            formIsValid = false;
            errors['address'] = 'آدرس خود را صحیح وارد کنید';
        }*/

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }



    handleEditSubmit(event){
        event.preventDefault()
        this.setState({
            requestInPageLoading : true
        })
        // console.log(this.state.fields)

        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('name' , this.state.fields.newName )
        data.append('telephone' , this.state.fields.newTelephone )

        axios.post(vars.PreUrl + 'https://www.lavefood.com//v1/user/info/edit' , data )


            .then(response => {

                let data = response.data.result[0]
                console.log(data)
                if (data.error === 0)
                {
                    this.setState({
                        requestInPageLoading : false,
                        fields : {
                            ...this.state.fields ,
                            name : this.state.fields.newName ,
                            telephone : this.state.fields.newTelephone ,
                        }
                    })

                    localStorage.setItem('name' , this.state.fields.newName)
                    localStorage.setItem('telephone' , this.state.fields.newTelephone)

                    this.setState({
                        requestInPageLoading : false ,
                        requestLoading : false ,
                        modal : {
                            modalMessageShow : true ,
                            modalMessageBody :  "عملیات موفقیت آمیز بود" ,
                            modalMessageTitle : "پیغام" ,


                        } ,
                        requestError : false ,
                    })
                }
                else{
                    this.setState({
                        requestInPageLoading : false ,
                        modal : {
                            modalMessageShow : true ,
                            modalMessageBody :  data.error_body ,
                            modalMessageTitle : "خطا" ,


                        },
                        requestError : true ,
                    })
                }
            })
            .catch(error => {
                this.setState({
                    requestInPageLoading : false ,
                    modal : {
                        modalMessageShow : true ,
                        modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                        modalMessageTitle : "خطا" ,


                    },
                    requestError : true,
                    discountCode : []
                })
                console.log(error)
            })



    }


    /*componentWillMount(){



    }*/

    handleLogOut(){
        localStorage.removeItem('city')
        localStorage.removeItem('users_ID')
        localStorage.removeItem('imeiCode')
        localStorage.removeItem('name')
        localStorage.removeItem('mobile')
        localStorage.removeItem('logged')
        localStorage.removeItem('usersCredit')
        localStorage.removeItem('telephone')
        localStorage.removeItem('creditUse')
        localStorage.removeItem('selectedDelivery')
        this.$f7router.navigate('/city/')
        return false
    }

    modalNameShow(){
        this.setState({
            nameModal : true ,
        })
    }
    modalTellShow(){
        this.setState({
            tellModal : true ,
        })
    }


    onPageBeforeIn(){

        this.props.toolbar(true)
    }

    onPageInit(){

    }
    componentDidMount(){

       /* if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {

            this.$f7router.navigate('/login-singup/' , true)
            return
        }*/

    }

    render(){
        const  { errors } = this.state

        if(this.state.goToLoginSignUp === true)
            return(
                <LoginSingUp />
            )
        else
        return(
            <Page name="profile" onPageBeforeIn={this.onPageBeforeIn.bind(this)} onPageInit={this.onPageInit.bind(this)}>



                <div id="profile" className="bg-white  pb-5">

                    <div id="header">
                        <img src="https://www.lavefood.com/webappassets/images/profile-cover.svg" className="cover"/>
                        <div id="name">
                            {localStorage.getItem('name')}
                        </div>
                        <div id="credit">
                            اعتبار شما:
                            <span className="price">
                                {localStorage.getItem('usersCredit')}
                            </span>
                            تومان
                        </div>
                    </div>



                    <div className="item-header" >
                        اطلاعات فردی
                    </div>
                    <Link className="item" onClick={this.modalNameShow.bind(this)} >
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/profile.svg" />

                        <div className="text" >
                            <div className="title">
                                نام و نام خانوادگی
                            </div>
                            <div className="sub-title">
                                {localStorage.getItem('name')}
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/edit.svg" />*/}
                    </Link>
                    <div className="item">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/smartphone-line.svg" />

                        <div className="text">
                            <div className="title">
                                تلفن همراه
                            </div>
                            <div className="sub-title">
                                {localStorage.getItem('mobile')}
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/edit.svg" />*/}
                    </div>
                    <div className="item" onClick={this.modalTellShow.bind(this)}>
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/phone-line.svg" />

                        <div className="text">
                            <div className="title">
                                تلفن ثابت
                            </div>
                            <div className="sub-title">
                                {localStorage.getItem('telephone')}
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/edit.svg" />*/}
                    </div>

                    <Link href="/my-address/" className="item">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/map3.svg" />

                        <div className="text">
                            <div className="sub-title">
                                آدرس های من
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />*/}
                    </Link>

                    <div className="item-header">
                        سایر
                    </div>

                    <Link href="/city/" className="item">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/map3.svg" />

                        <div className="text">
                            <div className="sub-title">
                                تغییر شهر
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />*/}
                    </Link>


                    <Link href="/events/" className="item">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/notification-2-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                رویدادها
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />*/}
                    </Link>

                    <div className="item" onClick={this.handleLogOut.bind(this)}>
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/logout-box-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                خروج
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/edit.svg" />*/}
                    </div>

                </div>




                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow} onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close" onClick={ () => this.state.requestError ? `` : this.setState({nameModal : false , tellModal : false}) }>
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>



                <Popup id="name-form-popup" swipeToClose opened={this.state.nameModal} onPopupClosed={() => this.setState({nameModal : false})}>
                    <Loading show={this.state.requestInPageLoading} />
                    <Page>
                        <Navbar title="ویرایش نام">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>
                        <div className="display-flex justify-content-center align-items-center h-100">

                            <form onSubmit={this.handleEditSubmit.bind(this)}   className="input-container pt-0">



                                <label htmlFor="phone" className="label">
                                    {/*<img src="https://www.lavefood.com/webappassets/images/gift.svg" className="img"/>*/}
                                    <div className="title">
                                        نام
                                    </div>
                                </label>
                                <div className="form-group">
                                    <input type="text" value={this.state.fields.newName} name="newName" onChange={this.handleChange.bind(this)} className="form-control input-field"/>
                                    <span className={["invalid-feedback" ,  errors['newName'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['newName'] }</span>
                                </div>


                                <div className="input-group">
                                    <button type="submit" className="btn btn-custom-4 ">
                                        ویرایش
                                    </button>
                                </div>

                            </form>



                        </div>
                    </Page>
                </Popup>



                <Popup id="tell-form-popup" swipeToClose opened={this.state.tellModal} onPopupClosed={() => this.setState({tellModal : false})}>
                    <Loading show={this.state.requestInPageLoading} />
                    <Page>
                        <Navbar title="ویرایش تلفن">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>
                        <div className="display-flex justify-content-center align-items-center h-100">

                            <form onSubmit={this.handleEditSubmit.bind(this)}   className="input-container pt-0">



                                <label htmlFor="phone" className="label">
                                    {/*<img src="https://www.lavefood.com/webappassets/images/gift.svg" className="img"/>*/}
                                    <div className="title">
                                        تلفن
                                    </div>
                                </label>
                                <div className="form-group">
                                    <input type="text" value={this.state.fields.newTelephone} name="newTelephone" onChange={this.handleChange.bind(this)} className="form-control input-field"/>
                                    <span className={["invalid-feedback" ,  errors['newTelephone'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['newTelephone'] }</span>
                                </div>


                                <div className="input-group">
                                    <button type="submit" className="btn btn-custom-4 ">
                                        ویرایش
                                    </button>
                                </div>

                            </form>



                        </div>
                    </Page>
                </Popup>


            </Page>

        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(Profile);